import React from "react";
import { toJsonText } from "../features/builder.utils";

// Read-only, pretty-printed JSON (schemas, computed field definitions). "None" for null.
export default function JsonBlock({ value }) {
  if (value === null || value === undefined) return <span className="text-xs text-text_muted">None</span>;
  return (
    <pre className="max-h-72 overflow-auto whitespace-pre-wrap break-words rounded-lg border border-border bg-surface_alt p-3 font-mono text-[11px] text-text_primary">
      {toJsonText(value)}
    </pre>
  );
}
